import { createSlice } from "@reduxjs/toolkit";
import getModalityStudy from "@custom/rtk-apis/modalityStudyRegion/getModalityStudy";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const getModalityStudySlice = createSlice({
  name: "getModalityStudySlice",
  initialState,
  reducers: {
    closeModal (state:any) { state.status = ""; }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getModalityStudy.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getModalityStudy.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(getModalityStudy.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default getModalityStudySlice.reducer;
export const { closeModal } = getModalityStudySlice.actions;
